import { useState } from "react";
import { Box, Card, TextField, Typography, Button } from "@mui/material";
import { motion } from "motion/react";
import { Link } from "react-router-dom";

const Login = () => {

    const [form, setForm] = useState({
        email: "",
        password: ""
    });

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(form);
    };

    return (
        <Box
            sx={{
                height: "75vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "linear-gradient(135deg, #0f172a, #1e293b)"
            }}
        >
            <motion.div
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                style={{ width: "100%", maxWidth: 400 }}
            >
                <Card
                    sx={{
                        p: 4,
                        borderRadius: 4,
                        backdropFilter: "blur(10px)",
                        background: "rgba(255,255,255,0.05)",
                        color: "#fff"
                    }}
                    elevation={0}
                >
                    <Typography variant="h5" mb={1} fontWeight="bold">
                        Bienvenido
                    </Typography>

                    <Typography variant="body2" mb={3} sx={{ opacity: 0.7 }}>
                        Inicia sesión para continuar
                    </Typography>

                    <form onSubmit={handleSubmit}>
                        <TextField
                            fullWidth
                            label="Correo"
                            name="email"
                            variant="outlined"
                            margin="normal"
                            value={form.email}
                            onChange={handleChange}
                            InputLabelProps={{ style: { color: "#ccc" } }}
                            sx={{
                                input: { color: "#fff" },
                                "& .MuiOutlinedInput-root": {
                                    "& fieldset": { borderColor: "#555" },
                                    "&:hover fieldset": { borderColor: "#888" },
                                    "&.Mui-focused fieldset": { borderColor: "#3b82f6" }
                                }
                            }}
                        />

                        <TextField
                            fullWidth
                            label="Contraseña"
                            name="password"
                            type="password"
                            variant="outlined"
                            margin="normal"
                            value={form.password}
                            onChange={handleChange}
                            InputLabelProps={{ style: { color: "#ccc" } }}
                            sx={{
                                input: { color: "#fff" },
                                "& .MuiOutlinedInput-root": {
                                    "& fieldset": { borderColor: "#555" },
                                    "&:hover fieldset": { borderColor: "#888" },
                                    "&.Mui-focused fieldset": { borderColor: "#3b82f6" }
                                }
                            }}
                        />

                        {/* Links debajo del password */}
                        <Box mt={1} display="flex" justifyContent="space-between">
                            <motion.span whileHover={{ scale: 1.05 }}>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        cursor: "pointer",
                                        color: "#60a5fa"
                                    }}
                                >
                                    ¿Olvidaste tu contraseña?
                                </Typography>
                            </motion.span>

                            <motion.span whileHover={{ scale: 1.05 }}>
                                <Typography
                                    component={Link}
                                    to="/registrarse"
                                    variant="body2"
                                    sx={{
                                        cursor: "pointer",
                                        color: "#60a5fa",
                                        textDecoration: "none"
                                    }}
                                >
                                    Regístrate
                                </Typography>
                            </motion.span>
                        </Box>

                        <motion.div
                            whileHover={{ scale: 1.03 }}
                            whileTap={{ scale: 0.97 }}
                        >
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                sx={{
                                    mt: 3,
                                    py: 1.2,
                                    borderRadius: 3,
                                    textTransform: "none",
                                    fontWeight: "bold",
                                    background: "linear-gradient(135deg, #3b82f6, #2563eb)"
                                }}
                            >
                                Entrar
                            </Button>
                        </motion.div>
                    </form>
                </Card>
            </motion.div>
        </Box>
    );
};

export default Login;